<div *ngIf="tableLines.length > 0" class="t-widget">
  <h3 class="t-widgetTitle">
    RX {{ rxGist.approveDate | date : "dd/MM/yyyy" }}
  </h3>
  <hr />
  <div class="tbl-teeth dense">
    <div class="p-datatable iscs-table iscs-table-auto">
      <table class="p-datatable-table">
        <thead class="p-datatable-thead">
          <tr>
            <th>{{ "translate.general.rxItem" | translate }}</th>
            <th>{{ "translate.general.rxStage" | translate }}</th>
            <th>
              {{ "translate.general.toothDisplayText" | translate }}
            </th>
          </tr>
        </thead>
        <tbody class="p-datatable-tbody">
          <tr *ngFor="let row of tableLines">
            <td>{{ row.rxItem?.text }}</td>
            <td>
              <span>{{ row.stage?.text }}</span>
            </td>
            <td>{{ row.toothDisplayText }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div *ngIf="implantTeeth.length > 0" class="t-widget">
  <h3 class="t-widgetTitle">
    {{ "translate.rx.implants" | translate }}
  </h3>
  <hr />
  <div class="tbl-implants dense">
    <div class="p-datatable iscs-table iscs-table-auto">
      <table class="p-datatable-table">
        <thead class="p-datatable-thead">
          <tr>
            <th>
              {{ "translate.rx.impCompany" | translate }}
            </th>
            <th>{{ "translate.rx.impType" | translate }}</th>
            <th>{{ "translate.rx.teeth" | translate }}</th>
          </tr>
        </thead>
        <tbody class="p-datatable-tbody">
          <tr *ngFor="let row of implantTeeth">
            <td>{{ row.implantCompany?.selectedValue?.text }}</td>
            <td>{{ row.implantType?.selectedValue?.text }}</td>
            <td>{{ row.id }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <ng-container *ngIf="attachmentsWithValues.length > 0">
    <h4>{{ "translate.rx.attachments" | translate }}</h4>
    <div class="rx-opt-container attach">
      <span *ngFor="let opt of attachmentsWithValues; let last = last">
        {{ getOptDisplayValue(opt) }} {{ opt.text
        }}<span *ngIf="!last"> | </span>
      </span>
    </div>
  </ng-container>
</div>
